import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';

export class Breadcrumbs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.data
        };
    }
    render() {
        return (
            <Breadcrumb listTag="div" style={{ marginBottom: '2rem' }}>
                {this.state.data.map((item, index) => ( // Added "index" as the second argument
                    <BreadcrumbItem key={index} active={item.active}>
                        <Link to={item.link}><FormattedMessage id={item.message} /></Link>
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>
        );
    }
}
